module.exports = __webpack_public_path__ + "static/media/dismiss-cross.1dee48ff.svg";